import React, { useState } from "react";
import { colors } from "./constants/colors";
import { ColorTile } from "./components/ColorTile";
import { useSpotifyAuth } from "./hooks/useSpotifyAuth";
import { useGetCurrentlyPlayingTrack } from "./hooks/useGetCurrentlyPlayingTrack";
import { MusicPlayer } from "./components/MusicPlayer";
import { useGetRecentListening } from "./hooks/useGetRecentListening";

function App() {
  // TODO: for all of these get their loading states and only when all of them are not loadnig then load the main app
  // loading profile
  const { profile, loading, accessToken } = useSpotifyAuth();
  // loading currently playing track
  const { currentlyPlaying } = useGetCurrentlyPlayingTrack(accessToken);
  // loading recent listening
  const { songs } = useGetRecentListening(accessToken);
  console.log("Recent Listening Tracks: ", songs);

  // STATE
  const [expandedTile, setExpandedTile] = useState<number | null>(-1);

  // CALLBACKS
  const handleTileClick = (index: number) => {
    if (index === expandedTile) {
      // closes
      setExpandedTile(null);
    } else {
      setExpandedTile(index);
    }
  };

  if (loading || !profile) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {/* what were doing here is defining an inline stylesheet for the scrolling div on the page */}
      <style>
        {`
          @keyframes scroll {
            0% {
              transform: translateX(0%);
            }
            100% {
              transform: translateX(-50%);
            }
          }
          .scrolling-text {
            animation: scroll 20s linear infinite;
            font-family: Snell Roundhand, cursive;
            font-size: 8rem;
            color: white;
            -webkit-text-stroke: 3px black;
            paint-order: stroke fill;
          }
        `}
      </style>
      <div className="min-h-screen flex items-center justify-center bg-gray-100 p-8 relative overflow-hidden">
        {/* Scrolling background text */}
        <div className="absolute inset-0 flex items-center pointer-events-none opacity-20">
          <div className="scrolling-text whitespace-nowrap">
            Music is Feeling Music is Feeling Music is Feeling Music is Feeling
            Music is Feeling Music is Feeling Music is Feeling Music is Feeling
          </div>
        </div>

        {/* Wrap grid in a container div, should be seperated into ColorGridComponents */}
        <div className="relative z-50 w-full max-w-xl">
          <div className="grid grid-cols-3 gap-4 w-full">
            {colors.map((color, index) => (
              <ColorTile
                key={index}
                name={color.name}
                bgClass={color.bgClass}
                feeling={color.feeling}
                isExpanded={index === expandedTile}
                handleTileClick={() => handleTileClick(index)}
              />
            ))}
          </div>
        </div>
        <div
          className="absolute bottom-0 left-0 right-0 ml-3"
          style={{ fontFamily: "Snell Roundhand, cursive", fontSize: "2rem" }}
        >
          hi, {profile.display_name}
        </div>
        <div className="absolute top-0 right-0 mr-3">
          <MusicPlayer currentlyPlaying={currentlyPlaying} />
        </div>
      </div>
    </>
  );
}

export default App;
